import { fetchJson } from 'api/fetcher'
import LenderName from 'state/enums/LenderName'

export interface Lender {
    id: number
    name: LenderName
    partner: boolean
}

interface LendersResponse {
    meta: {
        limit: number
        offset: number
        total_count: number
    }
    objects: Lender[]
}

export async function getLenders(): Promise<LendersResponse> {
    return fetchJson<LendersResponse>('v1/lender/?offset=0&limit=5000')
}
